import { setMirroringModeAction } from 'editor/src/store/design/slice';
import { MirroringMode } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

const setMirroringModeFromHostOperation =
  ({ mirroringMode }: { mirroringMode: MirroringMode | undefined }) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const { designData } = state.design;
    if (!designData) {
      return;
    }

    const page = designData.spreads[0]?.pages[0];
    if (!page) {
      return;
    }

    const contentIndex = page.groups.content?.findIndex((c) => c.name === 'Content Front');
    if (contentIndex === undefined || contentIndex < 0) {
      return;
    }

    dispatch(
      setMirroringModeAction({
        contentAddress: { spreadIndex: 0, pageIndex: 0, contentIndex },
        mirroringMode,
      }),
    );
  };

export default setMirroringModeFromHostOperation;
